import React, { useContext } from 'react'
import { InitializeContext } from '../../App';
import { Link } from "react-scroll";
import { navLinksData } from '../../data/navLinksData';

export default function Navbar() {
  const { toggleTheme, theme, scrollY } = useContext(InitializeContext);

  const scrollToHome = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const NavMenus = (
    <>
      {navLinksData.map(({ _id, title, link }) => (
        <li
          className="menu-item lg:mr-3 group"
          key={_id}
        >
          <Link
            activeClass={`border-b ${theme ? 'text-warning border-warning' : 'text-primary border-primary'}`}
            className={`py-4 px-6 my-1 uppercase shadow-md font-semibold border-b duration-300 ${theme ? 'group-hover:bg-transparent group-hover:text-warning border-transparent group-hover:border-warning' : 'group-hover:bg-transparent group-hover:text-primary group-hover:border-primary'}`}
            to={link}
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            onSetActive={() => {
              document.title = `${link === title.toLowerCase() ? `${title} | ` : ''}Toufiq Hasan Kiron`;
            }}
          >
            {title}
          </Link>
        </li>
      ))}
    </>
  )

  return (
    <div className={`hero sticky top-0 z-50 duration-300 ${theme ? 'text-white bg-[#212428]' : 'bg-[#ECF0F3] text-black'} ${scrollY > 50 ? "shadow-md" : ""}`}>
      <div className="hero-content gap-0 p-0 w-full">
        <section className={`hidden md:flex w-full`}>
          <div className="navbar md:justify-between md:px-5 py-3 md:py-1 lg:py-1 mx-auto">
            <div className="xl:navbar-start">
              <span onClick={scrollToHome} className={`btn bg-transparent hover:bg-transparent border-none ${theme ? 'text-white' : 'text-black'} normal-case text-lg flex justify-center items-center gap-2`} title='Toufiq Hasan Kiron'>Toufiq Hasan Kiron</span>
            </div>
            <div className="xl:navbar-end hidden md:flex gap-3">
              <ul className="menu menu-horizontal px-1 gap-3">
                {NavMenus}
              </ul>
              <span onClick={toggleTheme} className='cursor-pointer'>
                {
                  theme ? (
                    <i className='bx bx-sun text-xl duration-300 hover:text-warning'></i>
                  ) : (
                    <i className='bx bx-moon text-xl duration-300 hover:text-primary'></i>
                  )
                }
              </span>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
